import React, { useEffect, useRef, useState, useCallback } from "react";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import axios from "src/axios";
import { Checkbox, CardContent, Card, Fab, Table, Stack, Button, TableRow, TableBody, TableCell, Typography, TableContainer, FormControl, MenuItem, Select, InputLabel, Grid, Box, Dialog, DialogActions, DialogContent, TableHead, Zoom, Collapse, FormHelperText } from "@mui/material";
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { getURL } from "src/utils/config";
import { addInstruction, getInstructionInfo, setProtocolsInstructions, deleteInstruction } from "src/api/protocol";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ProtocolIndividual = () => {
  const [editingRow, setEditingRow] = useState(null);
  const [editedData, setEditedData] = useState({});
  const showSticker = true;
  const [errorCams, setErrorCams] = useState("");
  const [openError, setOpenError] = useState(false);
  const [activeTenents, setActiveTenents] = useState([]);
  const [checkValue, setCheckValue] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [displayedData, setDisplyedData] = useState([]);
  const [editedTenants, setEditedTenants] = useState([]);
  const [editedTenantsCheck, setEditedTenantsCheck] = useState({});
  const [tenentList, setTenentList] = useState([]);
  const [protocolsList, setProtocolsList] = useState([]);
  const [showAdd, setShowAdd] = useState(true);
  const [showClose, setShowClose] = useState(false);
  const [openAuto, setOpenAuto] = useState(false);
  const formRef = useRef(null);
  const userId = Number(localStorage.getItem("ID"));

  const toggleForm = () => {
    if (showForm) {
      setShowForm(false);
      setShowClose(false);
      setShowAdd(true);
      clearValues();
    } else {
      setShowForm(true);
      setShowClose(true);
      setShowAdd(false);

      // Focus on form after it's rendered
      setTimeout(() => {
        if (formRef.current) {
          formRef.current.focus();
          // Alternatively, focus on the first input field
          const firstInput = formRef.current.querySelector("input");
          if (firstInput) firstInput.focus();
        }
      }, 100);
    }
  };

  const getProtocolsList = useCallback(() => {
    const AUTHORIZATION = `Bearer ${localStorage.getItem("access_token")}`;

    axios({
      method: "get",
      url: `${getURL("/event-info/event-types")}`,
      headers: {
        Authorization: `${AUTHORIZATION}`,
      },
      validateStatus: function (status) {
        return status >= 200 || status === 400;
      },
    }).then(function (response) {
      if (response.status === 200) {
        setProtocolsList(response.data.filter(item => item.EventTypeStatus === 1));
      } else {
        console.log(response.data);
      }
    });
  },[userId]);

  const getSubLogins = useCallback(() => {
    const AUTHORIZATION = `Bearer ${localStorage.getItem("access_token")}`;

    axios({
      method: "get",
      url: `${getURL("/client/client-users")}?client_id=${userId}&type=tenent`,
      headers: {
        Authorization: `${AUTHORIZATION}`,
      },
      validateStatus: function (status) {
        return status >= 200 || status === 400;
      },
    }).then(function (response) {
      if (response.status === 200) {
        setTenentList(response.data);
      } else {
        console.log(response.data);
      }
    });
  },[userId]);

  useEffect(() => {
    getSubLogins();
    getProtocolsList();
  }, [getSubLogins, getProtocolsList]);

  

  const handleEditTenantChange = (event, value, index) => {
    let actTenents = [];

    if (value.some((obj) => obj.hasOwnProperty("selectall"))) {
      // Get current notifys for this specific row
      const currentRowTenants = editedTenants[index] || [];

      if (currentRowTenants.length === tenentList.length) {
        // Clear all for this specific row
        setEditedTenants((prev) => ({
          ...prev,
          [index]: [],
        }));
        // Remove the check for this specific row
        setEditedTenantsCheck((prev) => ({
          ...prev,
          [index]: false,
        }));
      } else {
        // Select all for this specific row
        tenentList.forEach((item) => {
          actTenents.push(item.Id);
        });
        setEditedTenants((prev) => ({
          ...prev,
          [index]: actTenents,
        }));
        // Set check for this specific row only
        setEditedTenantsCheck((prev) => ({
          ...prev,
          [index]: true,
        }));
      }
    } else {
      let id = value[0]?.Id;
      if (!id) return;

      setEditedTenants((prev) => {
        const currentRowTenants = prev[index] || [];
        let newTenants;

        if (currentRowTenants.includes(id)) {
          newTenants = currentRowTenants.filter((val) => val !== id);
        } else {
          newTenants = [...currentRowTenants, id];
        }

        // Update the check value for this specific row
        setEditedTenantsCheck((prevCheck) => ({
          ...prevCheck,
          [index]: newTenants.length === tenentList.length,
        }));

        return {
          ...prev,
          [index]: newTenants,
        };
      });
    }
  };

  const handleTenent = (event, value) => {
    let actTenents = [];
    if (value.some((obj) => obj.hasOwnProperty("selectall"))) {
      if (activeTenents.length === tenentList.length) {
        setActiveTenents([]);
        setCheckValue(false);
      } else {
        tenentList.forEach((item) => {
          actTenents.push(item.Id);
        });
        setActiveTenents(actTenents);
        setCheckValue(true);
      }
    } else {
      let id = value[0].Id;
      if (activeTenents.includes(id)) {
        let filterArr = activeTenents.filter((divid) => divid !== id);

        setActiveTenents(filterArr);
        if (checkValue) {
          setCheckValue(false);
        }
      } else {
        setActiveTenents((prv) => [...prv, id]);
      }
    }
  };

  useEffect(() => {
    if (
      activeTenents.length === tenentList.length &&
      activeTenents.length > 0
    ) {
      setCheckValue(true);
    }
  }, [activeTenents, tenentList]);

  const handleFilterOptions = (options, params) => {
    const filter = createFilterOptions();
    const filtered = filter(options, params);
    return [{ title: "Select All", selectall: true }, ...filtered];
  };


  const [formDetails, setFormDetails] = useState({
    introsionType: "",
    tenets: "",
    instructions: "",
  });

  const clearValues = () => {
    setFormDetails({
      introsionType: "",
      tenets: "",
      instructions: "",
    });

    setFormErrors({
      introsionType: "",
      instructions: "",
      tenets: "",
    });

    setActiveTenents([]);
    setCheckValue(false);
  };


  const [formErrors, setFormErrors] = useState({
    introsionType: "",
    instructions: "",
    tenets: "",
  });

  const [editErrors, setEditErrors] = useState({
    ProtocolId: "",
    Instructions: "",
  });

  const handleFormChange = (event, type) => {
    if (type) {
      setFormDetails((prv) => ({
        ...prv,
        [type]: event.target.value,
      }));
    }
  };

  const IntrusionDetails = (id, text) => {
    getInstructionInfo(id, (response) => {
      if (response.status === 200) {
        setDisplyedData(response.data);
      }
    });
  };

  const updateIntrusionTypes = (body) => {
    //console.log('body:',body);
    setProtocolsInstructions(body, (response) => {
      if (response.status === 200) {
        IntrusionDetails(0, (response) => {
          if (response.status === 200) {
            setDisplyedData(response.data);
            setEditedTenants([]);
          }
        });
      }
    });
  };

  useEffect(() => {
    IntrusionDetails(0);
  }, []);

  const addIntrosion = () => {
    const newErrors = {};


    if (!formDetails.introsionType) {
      newErrors.introsionType = "Protocol is required";
    }

    if (!formDetails.instructions.trim()) {
      newErrors.instructions = "Instruction is required";
    }

    if (activeTenents.length === 0) {
      newErrors.tenets = "Please Select Atleast One Notify";
    }

    if (displayedData.length > 0) {
      let isTypeAvailable = displayedData.filter(
        (item) =>
          Number(item.ProtocolId) ===
          Number(formDetails.introsionType)
      );
      if (isTypeAvailable.length > 0) {
        newErrors.introsionType = "Protocol already exists";
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setFormErrors(newErrors);
      return;
    }

    const payload = {
      ProtocolId: Number(formDetails.introsionType),
      Instructions: formDetails.instructions.trim(),
      TenantId: activeTenents.join(","), // Send comma-separated TenantIds
      ClientId : userId
    };

   // console.log('payload:',payload);

    addInstruction(payload, (response) => {
      if (response.status === 201) {
        setErrorCams("Protocol added successfully!");
        setOpenError(true);
        IntrusionDetails(0);

        setFormDetails({
          introsionType: "",
          instructions: "",
        });

        setFormErrors({
          introsionType: "",
          instructions: "",
          tenets: "",
        });

        setCheckValue(false);

        setActiveTenents([]);
      }
    });
  };

  const [delPopUp, setDelPopUp] = useState(false);
  const [delIndex, setDelIndex] = useState(null);

  const handleDelete = () => {
    let body = { Id: delIndex };
    deleteInstruction(body, (response) => {
      if (response.status === 200) {
        IntrusionDetails(0);
        setDelPopUp(false);
      }
    });
  };

  const handleCloseError = () => {
    setOpenError(false);
  };


  const handleUpdate = (type, index, item) => {
    if (type === "edit") {
      // Set the row to edit mode and store the current values
      setEditingRow(index);
      let userIds = [];
      if (item.UserId) {
        const cleanUserIdString = item.UserId.replace(/[[\]]/g, "");

        userIds = cleanUserIdString
          .split(",")
          .map((id) => parseInt(id.trim()))
          .filter((id) => !isNaN(id));
      }
      setEditedData({
        Id: item.Id, // Make sure to include the ID for updating
        ProtocolId: Number(item.ProtocolId) || "",
        Instructions: item.Instructions.trim() || "",
        TenantId: ""
      });

      setEditedTenants((prev) => ({
        ...prev,
        [index]: userIds,
      }));

      setEditedTenantsCheck((prev) => ({
        ...prev,
        [index]: userIds.length === tenentList.length,
      }));
    } else if (type === "save") {
      // Validate and save the data
      let tenetID = "";
      if (editedTenants) {
        tenetID = editedTenants[index].map(String);
      }
      const newErrors = {};
      

      if (!editedData.ProtocolId) {
        newErrors.ProtocolId = "Protocol is required";
      }

      if (!editedData.Instructions?.trim()) {
        newErrors.Instructions = "Instructions are required";
      }

      if (tenetID.length === 0) {
        newErrors.tenets = "Please Select Atleast One Notify";
      }

      if (displayedData.length > 0) {
        // Exclude the current row from duplicate check using Id
        let isTypeAvailable = displayedData.filter(
          (item) => {
            const isDuplicate =
              item.Id !== editedData.Id && 
              Number(item.ProtocolId) === Number(editedData.ProtocolId);
            return isDuplicate;
          }
        );
        if (isTypeAvailable.length > 0) {
          newErrors.ProtocolId = "Protocol already exists";
        }
      }

      if (Object.keys(newErrors).length > 0) {
        setEditErrors(newErrors);
        return;
      }

      const payload = {
        ...editedData,
        ProtocolId: Number(editedData.ProtocolId),
        Instructions: editedData.Instructions.trim().replace(/\n/g, "\\n"),
        TenantId: tenetID.length > 0 ? tenetID.join(",") : "",
        ClientId: userId
      };

      // Call update API with the edited data
      updateIntrusionTypes(payload);
      setEditingRow(null);
      setEditedData({});
      setEditErrors({});
    } else if (type === "cancel") {
      // Cancel editing
      setEditingRow(null);
      setEditedData({});
      setFormErrors({}); // Clear any errors
      setEditErrors({});
    } else if (type === "delete") {
      const currentData = displayedData[index];
      if (Object.keys(currentData).length !== 0) {
        let IntrusionId = currentData.Id;
        setDelPopUp(true);
        setDelIndex(IntrusionId);
      }
    }
  };

  const handleEditChange = (field, value) => {
    setEditedData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };


  const formatInstructions = (instructions) => {
    if (!instructions) {
      return (
        <Typography variant="body2" color="textSecondary">
          This message is currently unavailable.
        </Typography>
      );
    }

    // Replace escaped newlines (\\n) with actual newlines (\n) and split
    const lines = instructions
      .replace(/\\n/g, "\n")
      .split("\n")
      .filter((line) => line.trim() !== "");

    if (lines.length === 0) {
      return (
        <Typography variant="body2" color="textSecondary">
          This message is currently unavailable.
        </Typography>
      );
    }

    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          maxWidth: "fit-content", // Shrink to fit content
          width: "100%",
          textAlign: "left", // Left-align text within the content block
        }}
      >
        {lines.map((line, index) => (
          <Box key={index} sx={{ width: "100%" }}>
            <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
              <Typography
                component="span"
                variant="body2"
                sx={{
                  fontSize: "14px",
                  lineHeight: "1.5",
                  wordBreak: "break-word", // Ensure long text wraps
                  color: "textSecondary",
                }}
              >
                {line.trim()}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    );
  };


  const handleEditFilterOptions = (options, params, index) => {
    const filter = createFilterOptions();
    const filtered = filter(options, params);

    // Get current selected notifys for this row
    const currentTenants = editedTenants[index] || [];

    // Separate selected and unselected options
    const selectedOptions = filtered.filter((option) =>
      currentTenants.includes(option.Id)
    );
    const unselectedOptions = filtered.filter(
      (option) => !currentTenants.includes(option.Id)
    );

    // Sort options: selected options first, then unselected
    const sortedOptions = [...selectedOptions, ...unselectedOptions];

    return [{ title: "Select All", selectall: true }, ...sortedOptions];
  };

  const protocols = [
    "Weapon Detection",
    "Walking between cars in dark parking lot",
    "Trying to open a car door",
    "Trying to cut into a fence at a parking lot",
    "Loitering next to a building",
    "Vandalism",
    "Illegal Dumping",
    "Trespassing - Escalating for reference",
    "Suspicious Movement",
    "Camera Misaligned",
    "Behaviour Violation (Urination/Drug Usage/Other)",
    "Protocol Violation - Residents - Escalating for reference",
    "Protocol Violation - Workers - Escalating for Reference",
    "Protocol Violation - Suspicious Activity",
    "Unauthorized usage of Dumpster",
    "Unauthorized Entry/Exit",
    "Breaking in (Cars/Door)",
    "Fire/Smoke",
    "Tow Truck/Commercial vehicle/U-Haul Truck",
    "Emergency Services",
    "Trespassing - Suspicious",
    "Dog Off Leash",
    "Fence Jumping",
    "Moving Car"
  ]


  return (
    <Page title="Protocols">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={5}
      >
        <Box display="flex" alignItems="center">
          <Typography variant="h4" gutterBottom sx={{ mr: 2 }}>
            Protocols
          </Typography>

          {/* Add FAB next to the Protocols text */}
          {/* <Zoom in={showSticker} timeout={300}>
            <Tooltip
              title={showAdd ? "Add Protocol" : "Close"}
              placement="right"
              arrow
            >
              <Fab
                color="primary"
                aria-label="add-protocol-top"
                onClick={toggleForm}
                size="small"
                sx={{
                  boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                  "&:hover": {
                    transform: "scale(1.1)",
                    transition: "transform 0.2s ease-in-out",
                  },
                }}
              >
                {showAdd ? <AddIcon /> : <CloseIcon />}
              </Fab>
            </Tooltip>
          </Zoom> */}
        </Box>
      </Stack>

      {/* {addProtocol && ( */}
      <>
        {/* <Box mb={1}> */}
        <Card variant="outlined" sx={{ marginBottom: "8px" }}>
          <CardContent>
            <Grid container spacing={3} alignItems="center">
              <Scrollbar>
                <TableContainer>
                  {/* sx={{ minWidth: 800  , height: 'auto',maxHeight: 'calc(100vh - 200px)'}}> */}
                  <Box sx={{ maxHeight: 500, overflowY: "scroll" }}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow sx={{ backgroundColor: "#f2f2f2" }}>
                          <TableCell align="center">S.No</TableCell>
                          <TableCell align="center">Protocol</TableCell>
                          <TableCell align="center">Instructions</TableCell>
                          <TableCell align="center">Notify</TableCell>
                          <TableCell align="center">Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {displayedData.length > 0 ? (
                          displayedData.map((item, index) => (
                              <TableRow key={index}>
                                <TableCell align="center" style={{width:"100px"}}>{index + 1}</TableCell>
                                <TableCell align="center" sx={{
                                  width: "200px",
                                  overflow: "hidden",
                                  wordWrap: "break-word",
                                  whiteSpace: "normal",
                                }}>
                                  {editingRow === index ? (
                                    // <TextField
                                    //   value={editedData.ProtocolId || ""}
                                    //   onChange={(e) =>
                                    //     handleEditChange(
                                    //       "ProtocolId",
                                    //       e.target.value
                                    //     )
                                    //   }
                                    //   error={!!editErrors.ProtocolId}
                                    //   helperText={editErrors.ProtocolId}
                                    //   fullWidth
                                    //   multiline
                                    // />

                                    <FormControl fullWidth error={!!editErrors.ProtocolId}>
                                      <InputLabel id="protocol-name-label">Select Protocol</InputLabel>
                                      <Select
                                        labelId="protocol-name-label"
                                        label="Protocol"
                                        value={editedData.ProtocolId || ""}
                                        onChange={(e) => handleEditChange("ProtocolId", e.target.value)}
                                        autoComplete="off"
                                      >
                                      {protocolsList.map((protocol, idx) => (
                                          <MenuItem key={idx} value={protocol.Id}>
                                            {protocol.EventType}
                                          </MenuItem>
                                      ))}
                                      </Select>
                                      {editErrors.ProtocolId && (
                                        <FormHelperText>{editErrors.ProtocolId}</FormHelperText>
                                      )}
                                    </FormControl>
                                  ) : (
                                    item.ProtocolName
                                  )}
                                </TableCell>

                                <TableCell
                                  align="center"
                                  sx={{
                                    width: "450px",
                                    overflow: "hidden",
                                    wordWrap: "break-word",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  {editingRow === index ? (
                                    <TextField
                                      value={(
                                        editedData.Instructions || ""
                                      ).replace(/\\n/g, "\n")}
                                      onChange={(e) =>
                                        handleEditChange(
                                          "Instructions",
                                          e.target.value
                                        )
                                      }
                                      error={!!editErrors.Instructions}
                                      helperText={editErrors.Instructions}
                                      fullWidth
                                      multiline
                                      minRows={2}
                                      maxRows={10}
                                      variant="outlined"
                                      sx={{
                                        "& .MuiOutlinedInput-root": {
                                          alignItems: "flex-start",
                                          resize: "vertical",
                                        },
                                        "& .MuiOutlinedInput-input": {
                                          resize: "vertical",
                                          lineHeight: "1.2",
                                          fontSize: "14px",
                                        },
                                      }}
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter" && !e.shiftKey) {
                                          // Prevent default form submission on Enter and move to the next line
                                          e.preventDefault();
                                          const cursorPosition =
                                            e.target.selectionStart;
                                          const value =
                                            editedData.Instructions || "";
                                          const newValue =
                                            value.slice(0, cursorPosition) +
                                            "\n" +
                                            value.slice(cursorPosition);

                                          // Update the edited data, not the form details
                                          handleEditChange(
                                            "Instructions",
                                            newValue
                                          );

                                          // Move cursor to the next line
                                          setTimeout(() => {
                                            e.target.setSelectionRange(
                                              cursorPosition + 1,
                                              cursorPosition + 1
                                            );
                                          }, 0);
                                        }
                                      }}
                                    />
                                  ) : (
                                    <Box
                                      display="flex"
                                      flexDirection="column"
                                      gap={1}
                                      textAlign="center"
                                    >
                                      {formatInstructions(item.Instructions)}
                                    </Box>
                                  )}
                                </TableCell>
                                <TableCell
                                 align="center"
                                  sx={{
                                    width: "200px",
                                    overflow: "hidden",
                                    wordWrap: "break-word",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  {editingRow === index ? (
                                    <FormControl fullWidth>
                                      <Autocomplete
                                        multiple
                                        id={`notify-edit-${index}`}
                                        options={tenentList}
                                        getOptionLabel={(option) =>
                                          option.selectall &&
                                            tenentList.length ===
                                            (editedTenants[index] || []).length
                                            ? "Select All"
                                            : `${option.UserName}`
                                        }
                                        onChange={(event, value) =>
                                          handleEditTenantChange(
                                            event,
                                            value,
                                            index
                                          )
                                        }
                                        value={[]}
                                        filterOptions={(options, params) =>
                                          handleEditFilterOptions(
                                            options,
                                            params,
                                            index
                                          )
                                        }
                                        disableCloseOnSelect
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label="Select Notify"
                                            placeholder="Search Notify"
                                            error={!!editErrors.tenets}
                                            helperText={editErrors.tenets}
                                          />
                                        )}
                                        renderOption={(
                                          props,
                                          option,
                                          { selected }
                                        ) => (
                                          <li {...props}>
                                            {option.selectall ? (
                                              <>
                                                <Checkbox
                                                  icon={icon}
                                                  checkedIcon={checkedIcon}
                                                  sx={{
                                                    color: "#5c7fff",
                                                    "&.Mui-checked": { color: "#5c7fff" },
                                                  }}
                                                  style={{ marginRight: 8 }}
                                                  checked={
                                                    editedTenantsCheck[index] ||
                                                    false
                                                  }
                                                />
                                                {option.title}
                                              </>
                                            ) : (
                                              <>
                                                <Checkbox
                                                  icon={icon}
                                                  checkedIcon={checkedIcon}
                                                  sx={{
                                                    color: "#1e66e0",
                                                    "&.Mui-checked": { color: "#1e66e0" },
                                                  }}
                                                  style={{ marginRight: 8 }}
                                                  checked={(
                                                    editedTenants[index] || []
                                                  ).includes(option.Id)}
                                                />
                                                {`${option.UserName}`}
                                              </>
                                            )}
                                          </li>
                                        )}
                                        isOptionEqualToValue={(option, value) =>
                                          option.Id === value.Id
                                        }
                                      />
                                    </FormControl>
                                  ) :
                                    item.Name && item.Name !== "[]" ? (
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: 0.5,
                                          alignItems: "center",
                                          justifyContent: "center",
                                          width: "100%",
                                        }}
                                      >
                                        {item.Name.replace(/[[\]]/g, "")
                                          .split(",")
                                          .map((name, idx) => (
                                            <Typography
                                              key={idx}
                                              variant="body2"
                                              sx={{
                                                textAlign: "center",
                                                padding: "2px 0",
                                                width: "100%",
                                              }}
                                            >
                                              {name.trim()}
                                            </Typography>
                                          ))}
                                      </Box>
                                    ) : (
                                      <Typography
                                        variant="body2"
                                        color="textSecondary"
                                      >
                                        No Notify assigned
                                      </Typography>
                                    )}
                                </TableCell>
                                <TableCell align="center" style={{width:"300px"}}>
                                  {editingRow === index ? (
                                    <Box sx={{marginLeft:"30px"}}
                                    >
                                      <Button
                                        variant="contained"
                                        onClick={() =>
                                          handleUpdate("save", index, item)
                                        }
                                        sx={{
                                          marginRight: { xs: 0, sm: "6px" },
                                          marginBottom: { xs: "8px", sm: "3px" },
                                          color: "#ffffff",
                                          '&:hover': {
                                            color:'#ffffff',
                                          }
                                        }}
                                      >
                                        Save
                                      </Button>
                                      <Button
                                        variant="contained"
                                        onClick={() =>
                                          handleUpdate("cancel", index)
                                        }
                                        sx={{
                                          marginRight: { xs: 0, sm: "3px" },
                                          marginBottom: { xs: "8px", sm: "3px" },
                                          color: "#ffffff",
                                          '&:hover': {
                                            color:'#ffffff',
                                          }
                                        }}
                                      >
                                        Cancel
                                      </Button>
                                    </Box>
                                  ) : (
                                      <Box
                                        sx={{
                                          marginTop: "15px",marginLeft:"30px"
                                        }}
                                      >
                                        <Button
                                          variant="contained"
                                          onClick={() =>
                                            handleUpdate("edit", index, item)
                                          }
                                          sx={{
                                            marginRight: { xs: 0, sm: "6px" },
                                            marginBottom: { xs: "8px", sm: "3px" },
                                            color: "#ffffff",
                                            '&:hover': {
                                              color:'#ffffff',
                                            }
                                          }}
                                        >
                                          Edit
                                        </Button>
                                        <Button
                                          variant="contained"
                                          onClick={() =>
                                            handleUpdate("delete", index, item)
                                          }
                                          sx={{
                                            marginLeft: { xs: 0, sm: "3px" },
                                            marginBottom: { xs: "8px", sm: "3px" },
                                            color: "#ffffff",
                                            '&:hover': {
                                              color:'#ffffff',
                                            }
                                          }}
                                        >
                                          Delete
                                        </Button>
                                      </Box>
                                  )}
                                </TableCell>
                              </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={6}
                              style={{ textAlign: "center", fontWeight: "bold" }}
                            >
                              No Data
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </Box>
                </TableContainer>
              </Scrollbar>
            </Grid>
          </CardContent>
        </Card>

        {/* <Zoom in={showSticker} timeout={300}>
          <Tooltip
            title={showAdd ? "Add Protocol" : "Close"}
            placement="right"
            arrow
          >
            <Fab
              color="primary"
              aria-label="add-protocol"
              onClick={toggleForm}
              size="small"
              sx={{
                position: "fixed",
                bottom: 24,
                right: 24,
                zIndex: 1000,
                boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
                "&:hover": {
                  transform: "scale(1.1)",
                  transition: "transform 0.2s ease-in-out",
                },
              }}
            >
              {showAdd && !showClose ? (
                <AddIcon />
              ) : showClose && !showAdd ? (
                <CloseIcon />
              ) : (
                ""
              )}
            </Fab>
          </Tooltip>
        </Zoom> */}
        {/* </Box> */}



        {showForm && (
          <Collapse in={showForm} timeout={300} unmountOnExit>
            <Box ref={formRef} tabIndex={-1}>
              <Card>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={6} sm={3}>
                      {/* <TextField
                        label="Protocol Name"
                        value={formDetails.introsionType}
                        onChange={(e) => handleFormChange(e, "introsionType")}
                        error={!!formErrors.introsionType}
                        helperText={formErrors.introsionType}
                        autoComplete="off"
                        fullWidth
                      /> */}

                      <FormControl fullWidth error={!!formErrors.introsionType}>
                        <InputLabel id="protocol-name-label">Select Protocol</InputLabel>
                        <Select
                          labelId="protocol-name-label"
                          label="Protocol"
                          value={formDetails.introsionType}
                          onChange={(e) => handleFormChange(e, "introsionType")}
                          autoComplete="off"
                        >
                          {protocolsList.map((protocol, idx) => (
                            <MenuItem key={idx} value={protocol.Id}>
                              {protocol.EventType}
                            </MenuItem>
                          ))}
                        </Select>
                        {formErrors.introsionType && (
                          <FormHelperText>{formErrors.introsionType}</FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                      <TextField
                        label="Instructions"
                        value={formDetails.instructions}
                        onChange={(e) => handleFormChange(e, "instructions")}
                        error={!!formErrors.instructions}
                        helperText={formErrors.instructions}
                        autoComplete="off"
                        fullWidth
                        multiline
                        //rows={4}
                        minRows={2}
                        maxRows={10}
                        variant="outlined"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            alignItems: "flex-start",
                            resize: "vertical",
                            padding: "7px",
                          },
                          "& .MuiOutlinedInput-input": {
                            resize: "vertical",
                            lineHeight: "1.5",
                            fontSize: "14px",
                            //minHeight: '10px',
                          },
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && !e.shiftKey) {
                            // Prevent default form submission on Enter and move to the next line
                            e.preventDefault();
                            const cursorPosition = e.target.selectionStart;
                            const value = formDetails.instructions;
                            const newValue =
                              value.slice(0, cursorPosition) +
                              "\n" +
                              value.slice(cursorPosition);
                            setFormDetails((prev) => ({
                              ...prev,
                              instructions: newValue,
                            }));
                            // Move cursor to the next line
                            setTimeout(() => {
                              e.target.setSelectionRange(
                                cursorPosition + 1,
                                cursorPosition + 1
                              );
                            }, 0);
                          }
                        }}
                      />
                    </Grid>

                    <Grid item xs={6} sm={3}>
                      <FormControl fullWidth>
                        <Autocomplete
                          multiple
                          id="tags-outlined-client"
                          options={tenentList}
                          onChange={handleTenent}
                          value={[]}
                          getOptionLabel={(option) =>
                            option.selectall &&
                              tenentList.length === activeTenents.length
                              ? "Select All"
                              : `${option.UserName}`
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Notify"
                              placeholder="Search Notify Name..."
                              error={!!formErrors.tenets}
                              helperText={formErrors.tenets}
                            />
                          )}
                          disableCloseOnSelect={openAuto}
                          open={openAuto}
                          onOpen={() => setOpenAuto(true)}
                          onClose={() => setOpenAuto(false)}
                          filterOptions={handleFilterOptions}
                          renderOption={(props, option, { selected }) => (
                            <li {...props}>
                              {option.selectall ? (
                                <>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    sx={{
                                      color: "#1e66e0",
                                      "&.Mui-checked": { color: "#1e66e0" },
                                    }}
                                    style={{ marginRight: 8 }}
                                    checked={checkValue}
                                  />
                                  {option.title}
                                </>
                              ) : (
                                <>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    sx={{
                                      color: "#1e66e0",
                                      "&.Mui-checked": { color: "#1e66e0" },
                                    }}
                                    style={{ marginRight: 8 }}
                                    checked={activeTenents.includes(option.Id)}
                                    onChange={() => {
                                      const isChecked = activeTenents.includes(
                                        option.Id
                                      );
                                      const newActiveTenets = isChecked
                                        ? activeTenents.filter(
                                          (Id) => Id !== option.Id
                                        )
                                        : [...activeTenents, option.Id];
                                      setActiveTenents(newActiveTenets);
                                    }}
                                  />
                                  {`${option.UserName}`}
                                </>
                              )}
                            </li>
                          )}
                          isOptionEqualToValue={(option, value) =>
                            option.Id === value.Id
                          }
                        />
                      </FormControl>
                    </Grid>

                    <Grid
                      item
                      xs={2}
                      sx={{ height: "100%", marginTop: "10px" }}
                    >
                      <Button
                        variant="contained"
                        onClick={addIntrosion}
                        sx={{
                          marginRight:'6px',
                          color: "#ffffff",
                          '&:hover': {
                            color:'#ffffff',
                          }
                        }}
                      >
                        Add
                      </Button>
                      <Button
                        variant="contained"
                        onClick={clearValues}
                        sx={{
                          color: "#ffffff",
                          '&:hover': {
                            color:'#ffffff',
                          }
                        }}
                      >
                        Clear
                      </Button>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Box>
          </Collapse>
        )}
      </>
      {/* // )} */}

      <Zoom in={showSticker} timeout={300}>
        <Fab
          variant="extended"
          aria-label="add-notify"
          onClick={toggleForm}
          size="medium"
          sx={{
            top: 10,
            zIndex: 1000,
            boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
            color: "#ffffff", // 🔹 text color (white)
            backgroundColor: "#5c7fff",
            "&:hover": {
              backgroundColor: "#1E3A8A",
              color: "#ffffff", // keep text white on hover too
              transform: "scale(1.1)",
              transition: "transform 0.2s ease-in-out",
            },
          }}
        >
          {showAdd && !showClose ? "Add Protocol" : showClose && !showAdd ? "Close" : ""}
        </Fab>
      </Zoom>


      <Dialog
        open={openError}
        onClose={handleCloseError}
        maxWidth="xs"
        fullWidth
      >
        <DialogContent>
          <Typography variant="h6">{errorCams}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseError} variant="contained" sx={{
            color: "#ffffff",
              '&:hover': {
                color:'#ffffff',
            }
          }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={delPopUp}>
        <DialogContent>Are you sure you want to Delete the Protocol?</DialogContent>
        <DialogActions>
          <Button 
            variant="contained" onClick={() => setDelPopUp(false)} 
            sx={{
            color: "#ffffff",
            '&:hover': {
              color:'#ffffff',
            }
          }}>
            No
          </Button>
          <Button variant="contained" sx={{
            color: "#ffffff",
            '&:hover': {
              color:'#ffffff',
            }
          }} onClick={handleDelete}>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

    </Page>
  );
};


export default ProtocolIndividual;
